import React from 'react';

export const Input = ({ value, onChange, type = 'text', className , disabled}) => {
    return (
        <input
            type={type}
            value={value}
            onChange={onChange}
            className={`border border-gray-300 rounded p-2 ${className}`}
            disabled={disabled}
        />
    );
};
